import {
  drawerWidth,
  drawerMiniWidth,
  transition,
  containerFluid,
} from "assets/jss/material-dashboard-pro-react.jsx";

const appStyle = (theme) => ({
  wrapper: {
    position: "relative",
    height: "100vh",
  },
  mainPanel: {
    transitionProperty: "top, bottom, width",
    transitionDuration: ".2s, .2s, .35s",
    transitionTimingFunction: "linear, linear, ease",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    position: "relative",
    float: "right",
    ...transition,
    height: "100%",
    width: "100%",
    overflowScrolling: "touch",
  },
  content: {
    marginTop: "17px",
    padding: "30px 15px",
    paddingTop: "10px",
    minHeight: "calc(100vh - 123px)",
    height: "100%",
    "&.dashboard":{
      minHeight:"unset",
      maxHeight:"calc(100vh - 40px)",
      // border:'1px solid purple'
    }
  },
  container: { ...containerFluid },
  map: {
    marginTop: "70px",
  },
  mainPanelSidebarMini: {
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerMiniWidth}px)`,
    },
  },
  mainPanelWithPerfectScrollbar: {
    overflow: "hidden !important",
  },
});

export default appStyle;
